import { OverlayAction } from '../reducers/overlay'
import { layoutActions, ModalsType } from '@Techedge/digitalportal-shared'

export const openProjectCreation = () => (dispatch) => {
	dispatch(layoutActions.setModals({ type: ModalsType.NEW_ACTIVITY }))
}

export const closeProjectCreation = () => {
	return { type: OverlayAction.CLOSE_PROJECT_CREATION }
}

export const setShowAppLoader = (showAppLoader: boolean) => {
	return { type: OverlayAction.SET_SHOW_APP_LOADER, showAppLoader }
}

export const setIsAppLoaded = (isAppLoaded: boolean) => {
	return { type: OverlayAction.SET_IS_APP_LOADED, isAppLoaded }
}

export const openResourceCreation = () => (dispatch) => {
	dispatch(layoutActions.setModals({ type: ModalsType.NEW_RESOURCE }))
}

export const closeResourceCreation = () => () => {
	return { type: OverlayAction.CLOSE_RESOURCE_CREATION }
}

export const openChatbot = () => (dispatch) => {
	dispatch(layoutActions.setIsChatbotOpen(true))
}

export const openDocumentCreation = () => (dispatch) => {
	let referenceFolderId = null
	let pathname = window.location.pathname
	if (pathname) {
		if (pathname.includes('/subfolder/')) {
			referenceFolderId = pathname.split('/subfolder/')[1]
		}
		if (pathname.includes('/folder/')) {
			referenceFolderId = pathname.split('/folder/')[1]
		}
	}
	dispatch(
		layoutActions.setModals({
			type: ModalsType.NEW_RESOURCE,
			props: {
				referenceFolderId: referenceFolderId,
				isOpenDocument: true,
				resourceType: 'file',
			},
		})
	)
}

export const openSubfolderCreation = () => (dispatch) => {
	let referenceFolderId = null
	let pathname = window.location.pathname
	if (pathname) {
		if (pathname.includes('/folder/')) {
			referenceFolderId = pathname.split('/folder/')[1]
		}
	}
	dispatch(
		layoutActions.setModals({
			type: ModalsType.NEW_RESOURCE,
			props: {
				resourceType: 'sub-folder',
				referenceFolderId: referenceFolderId,
			},
		})
	)
}

export const openFolderCreation = () => (dispatch) => {
	dispatch(
		layoutActions.setModals({
			type: ModalsType.NEW_RESOURCE,
			props: { resourceType: 'folder' },
		})
	)
}

export const openDiscussionCreation = () => (dispatch) => {
	dispatch(layoutActions.setModals({ type: ModalsType.NEW_FORUM }))
}
export const setShowAddPhotoDialog = (payload) => (dispatch) => {
	dispatch({ type: OverlayAction.SET_SHOW_ADD_PHOTO_DIALOG, payload })
}
export const openPhotoCreation = () => {
	return setShowAddPhotoDialog(true)
}

export const showToastUploadPhotoError = (text: string) => {
	return {
		type: OverlayAction.SHOW_TOAST_UPLOAD_PHOTO_ERROR,
		toastList: [{ text }],
	}
}
